<template>
	<div
		class="card"
		:id="'bid_'+_bid.id"
		:ref="'bid_' + _bid.id"
		v-bind:class="[
			{
				inactive: _time.diff(_bid.finish) > 0,
				winner: is_winner && user,
				loser: !is_winner && _bid.Wishlist != null && _bid.Wishlist.is_bid == 1,
			},
		]"
	>
		<div class="card-image has-ribbon">
			<div class="ribbon has-ribbon-left pointer">
				<router-link target="_blank" :to="{ name: 'Product', params: { id:_bid.id } }">
					<b-icon type="is-primary" icon="external-link-alt" size="is-small" :title="$t('Open in new window')"></b-icon>
				</router-link>
			</div>
			<div v-if="$store.getters.loggedIn && currentPage !== '/'" class="ribbon pointer" @click="_AddToFavorites(_bid)">
				<b-icon
					v-if="_bid.Wishlist==null||(_bid.Wishlist&&_bid.Wishlist.is_watch==0||_bid.Wishlist.is_watch==null)"
					type="is-primary"
					icon="heart"
					size="is-small"
					:title="$t('Add to favorites')"
				></b-icon>
				<b-icon v-else type="is-danger" icon="heart" size="is-small" :title="$t('Remove from favorites')"></b-icon>

			</div>

			<router-link :to="{ name: 'Product', params: { id:_bid.id } }" class="image is-square">
				<v-lazy-image :src="_bid.Product.img_card" aspect-ratio="1" :alt="_bid.Product.name" />
			</router-link>
		</div>
		<div class="card-content column">
			<span>#{{_bid.Product.sku}} {{ $t('item') }}</span>
			<h4 v-if="currentPage !== '/'" class="is-size-5 product-title pointer" @click="_singleProduct(_bid.id)">
				<span v-if="$i18n.locale == 'hu'">
					{{ _bid.Product.name }}
				</span>
				<span v-else>
					{{ _lang.en.name ? _lang.en.name : _bid.Product.name }}
				</span>
			</h4>
			<h4 v-else class="is-size-5 product-title">
				<router-link :to="{ name: 'Product', params: { id:_bid.id } }">
					<span v-if="$i18n.locale == 'hu'">
						{{ _bid.Product.name }}
					</span>
					<span v-else>
						{{ _lang.en.name ? _lang.en.name : _bid.Product.name }}
					</span>
				</router-link>
			</h4>
			<!-- Taglist  -->
			<!-- category types: tag: 6, city: 5, region: 4, country: 3, continent: 2, category: 1 -->
			<template v-if="currentPage !== '/'">
				<div class="buttons buttons-tags">
					<b-button v-for="(pc, index) in categoryWithoutMain" :key="index" @click="putToStorage(pc)"  size="is-small">
						<span v-if="$i18n.locale == 'hu'">
							{{ pc.name }}
						</span>
						<span v-else>
							{{ pc.languages && pc.languages.en ? pc.languages.en : pc.name }}
						</span>
					</b-button>
				</div>
			</template>
			<template v-else>
				<div class="buttons buttons-tags">
					<b-button v-for="(pc, index) in categoryWithoutMain" :key="index" tag="router-link" :to="{ name: 'Products' }" size="is-small">
						<span v-if="$i18n.locale == 'hu'">
							{{ pc.name }}
						</span>
						<span v-else>
							{{ pc.languages && pc.languages.en ? pc.languages.en : pc.name }}
						</span>
					</b-button>
				</div>
			</template>
			<div v-if="_time.diff(_bid.finish) < 0 && _bid.Auction.status == 'active'" class="running-data">
				<div class="columns is-mobile is-multiline is-gapless is-vcentered">
					<div v-if="_bid.nr_of_bets == 0" class="column has-text-centered">
						{{ remTimeFormat(_time, _bid.finish) }}
					</div>
					<div v-else class="column is-narrow">
						{{ remTimeFormat(_time, _bid.finish) }}
					</div>
					<div v-if="_bid.nr_of_bets > 0" class="column">
						<div :title="$t('Winning user')+': '+_bid.winner_name" class="has-text-right">
							<b-icon v-if="_bid.nr_of_bets >= 10" icon="angle-double-up" size="is-small" type="is-danger"></b-icon>
							<b-icon v-else-if="_bid.nr_of_bets >= 5" icon="angle-up" size="is-small" type="is-danger"></b-icon>
							<span class="has-text-danger">{{_bid.nr_of_bets}} {{ $tc('bids', _bid.nr_of_bets) }}</span>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="has-text-centered">
				<span v-if="_bid.status > 0">
					<span v-if="_bid.winner_id">
						<span v-if="_bid.winner_id == $store.getters.userid">
							{{ $t('You won the product.') }}
						</span>
						<span v-else>
							<span v-if="_bid.Wishlist && _bid.Wishlist.is_bid == 1">
								{{ $t('You did not win the product.') }}
							</span>
							<span v-else>
								{{ $t('Sold') }}
							</span>
						</span>
					</span>
					<span v-else>
						{{ $t('Auction is closed') }}
					</span>
				</span>
				<span v-else-if="_bid.Auction.status == 'visible'">{{ $t('Coming soon') }}</span>
			</div>
		</div>
		<footer class="card-footer">
			<div class="column">
				<div class="bid-price-title has-text-centered">
					<div v-if="_bid.Auction.status == 'active' && _bid.winner_id !== null">
						<transition name="fade" mode="out-in">
							<div :key="_bid.price">
								<p>
									<span v-if="_time.diff(_bid.finish) < 0">
										{{ $t('Current price') }}:
									</span>
									<span v-else>
										{{ $t('Buyout price') }}:
									</span>
									{{ _bid.price | toCurrency($data._this, _currency) }}
								</p>
							</div>
						</transition>
					</div>
					<div v-else-if="_bid.winner_id == null">
						<transition name="fade" mode="out-in">
							<div :key="_bid.price">
								<p>
									{{ $t('Opening price') }}:
									{{ _bid.Product.price | toCurrency($data._this, _currency) }}
								</p>
							</div>
						</transition>
					</div>
					<div v-else>
						<p>
							{{ $t('Opening price') }}:
							{{ _bid.Product.price | toCurrency($data._this, _currency) }}
						</p>
					</div>
				</div>

				<b-field v-if="!isHidden && _bid.Auction.status == 'active' && currentPage !== '/'" type="is-primary">
					<b-input
						type="number"
						custom-class="bidfield"
						v-model="bid_price"
						v-on:keypress.enter.native="sendLicit(new_bid.price, currency)"
						expanded
					>
					</b-input>
					<div class="control">
						<b-button type="is-primary" v-on:click="sendLicit(bid_price, currency)">{{ $t('Place bid') }}</b-button>
					</div>
				</b-field>
				<b-field
					v-if="
						currentPage !== '/' &&
						$store.getters.loggedIn == true &&
						_time.diff(_bid.finish) < 0 &&
						_bid.Auction.status == 'active' &&
						isHidden
					"
				>
					<b-button v-on:click="isHidden = false" type="is-primary" expanded>{{ $t('Instant bid') }}</b-button>
				</b-field>
			</div>
		</footer>
	</div>
</template>
<script>
import VLazyImage from 'v-lazy-image'

export default {
	name: 'ProductCard',
	props: ['_bid', '_index', '_time', '_currency', '_cardTagfilter', '_lang', '_singleProduct'],
	components: {
		VLazyImage,
	},
	data() {
		return {
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
			isHidden: true,
			currency: localStorage.getItem('currency') || 'HUF',
			bid_price: 0,
			is_winner: false,
			new_bid: {},
			firstBid: 0,
			user: null,
			lastBet: 0,
			winner: {},
			bid_id: 0,
		}
	},
	methods: {
		hufToCurrency(val) {
			var ret = this.$options.filters.toCeil(this.$options.filters.fromToCurrency(val, this, 'HUF', this.currency))
			return ret
		},
		_AddToFavorites(bid) {
			console.log('BID:', bid.Wishlist)
			var _this = this
			_this.$http
				.post('user/watch', {
					bid_id: bid.id,
					is_watch: bid.Wishlist && bid.Wishlist.is_watch == 1 ? 0 : 1,
				})
				.then((response) => {
					_this._bid.Wishlist = response.data.wishlist
					let msg = _this.$t('Removed from favorites')
					if (response.data.wishlist.is_watch) {
						msg = _this.$t('Added to favorites')
					}
					_this.$buefy.snackbar.open({
						message: msg,
						queue: false,
					})
				})
				.catch((error) => {
					_this.$buefy.snackbar.open({
						message: _this.$t('Failed to add to favorites'),
						type: 'is-danger',
						duration: 5000,
						queue: false,
					})
					console.log(error)
				})
		},
		sendLicit(_newprice, _currency) {
			var _this = this
			//e.preventDefault();
			if (this.$store.getters.loggedIn == true) {
				this.user = this.$store.getters.userid
			}
			this.new_bid.currency = _currency
			this.new_bid.price = _newprice
			console.log('user bid::::', this.user, this.new_bid)
			this.$socket.emit(
				'sendLicit',
				{
					user: { id: _this.user, token: localStorage.getItem('token') },
					product: _this._bid.Product,
					bid: _this._bid,
					new_bid: _this.new_bid,
				},
				function (data_full) {
					console.log('$respLicit():', data_full)
					var data = data_full.data
					console.log('$respLicit() data:', data)
					console.log('data.err:', data_full.err)
					var hasError = !!data_full.err
					_this.has_success = !hasError
					_this.has_error = hasError
					if (data.last_bet != null) {
						_this.lastBet = data.last_bet
					}
					_this._bid.bid_step = data_full.bidStep
					_this._bid.winner_id = data_full.winner.id
					_this.is_winner = _this.user == data_full.winner.id;
					console.log('NEW POSSIBLE BID:', data.price, data_full.bidStep)
					//_this.bid_price = data.price + data.bid_step;

					// feedback
					var msg = 'bid.' + data_full.message
					console.log('USER:', _this.user, 'WINNERID:', data_full.winner.id)
					if (!data_full.err) {
						if (_this.user == data_full.winner.id) {
							msg = 'Your bid is winning now.'
						} else {
							msg = 'You were overbid.'
						}
					}

					_this.$buefy.snackbar.open({
						type: !data_full.err && _this.user == data_full.winner.id ? 'is-success' : 'is-warning',
						message: _this.$t(msg),
						queue: false,
					})

					_this.setBackground(_this, data_full.winner.id,true)
					_this.sockets.subscribe('bid_' + _this._bid.id, (data) => {
						console.log('SUBSCRIBE', _this._bid.id)
						_this.winner = data.User
						_this._bid.price = data.data.price
						_this._bid.winner_id = data.winner.id
						_this.is_winner = _this.user == data.winner.id;

						console.log('bid_' + _this._bid.id, _this._bid, data)
						//_this.bid_price = data.data.price + data.bidStep;
						_this.setBackground(_this, data.winner.id)
						if (_this._bid.Wishlist) {
							_this._bid.Wishlist.is_bid = 1
						} else {
							_this._bid.Wishlist = { is_bid: 1 }
						}
					})
				}
			)
			//console.log("SUBSCRIBING product_" + this._bid.Product.id);
		},
		putToStorage(category) {
			this.$root.$emit('refreshFilters', category)
		},
		setBackground(_this_, winner,isbidded) {
			if(typeof isbidded === "undefined"){
				isbidded = false;
			}
			console.log('SETBG U: ', winner, _this_.user)
			console.log('FIND', 'bid_' + _this_._bid.id)
			console.log('SETBG:', typeof _this_.$refs['bid_' + _this_._bid.id], _this_._bid.id)
			if (typeof document.getElementById('bid_' + _this_._bid.id) !== 'undefined') {
				if (winner == _this_.user) {
					console.log("WINNER")
					document.getElementById('bid_' + _this_._bid.id).classList.remove('loser');
					document.getElementById('bid_' + _this_._bid.id).classList.add('winner');
					//_this_.$refs['bid_' + _this_._bid.id].classList.remove('loser')
					//_this_.$refs['bid_' + _this_._bid.id].classList.add('winner')
				} else if ((_this_._bid.Wishlist && _this_._bid.Wishlist.is_bid == 1) || isbidded) {
					console.log("LOSER")
					document.getElementById('bid_' + _this_._bid.id).classList.remove('winner');
					document.getElementById('bid_' + _this_._bid.id).classList.add('loser');
					//_this_.$refs['bid_' + _this_._bid.id].classList.remove('winner')
					//_this_.$refs['bid_' + _this_._bid.id].classList.add('loser')
				}
				console.log('BG:', _this_.$refs['bid_' + _this_._bid.id], _this_._bid.id)
			}
		},
	},
	computed: {
		currentPage() {
			return this.$route.path
		},
		categoryWithoutMain: function () {
			if (typeof this._bid.Product.Categories === 'undefined') {
				return null
			}
			return this._bid.Product.Categories.filter(function (cat) {
				return cat.type !== 1 && cat.id !== 8235 && cat.hidden !== 1
			})
		},
	},
	mounted() {
		//console.log('mounted')
		var _this = this
		if (this.$store.getters.loggedIn == true) {
			this.user = this.$store.getters.userid
		}
		if (this._bid.Product) {
			//console.log('___CARD:', this._bid.Product);
			// if(this._bid == null){
			// 	this._bid = this.bidSample;
			// }
			this.bid = this._bid
			//this.bid_price = this._bid.price;
			this.is_winner = this.user ==  this._bid.winner_id;
			//console.log("BID:",this.bid.winner_id)

			this.firstBid = 0
			if (!this.bid.winner_id) {
				this.firstBid = this.bid.bid_step
			}
			this.bid_price =
				(this.bid.price > this.bid.Product.price ? this.bid.price : this.bid.Product.price) +
				this.bid.bid_step -
				this.firstBid

			this.bid_price = this.hufToCurrency(this.bid_price)

			this.long_description = this._bid.Product.long_description
				? JSON.parse(this._bid.Product.long_description)
				: { en: null }

			//if(this._bid.Wishlist&&this._bid.Wishlist.is_bid==1){
			_this.sockets.subscribe('bid_' + this._bid.id, (data) => {
				console.log('SUBSCRIBE', _this._bid.id, data)
				_this.winner = data.User;
				_this.is_winner = _this.user == data.winner.id;
				_this._bid.price = data.data.price;
				_this._bid.nr_of_bets = data.bets;
				_this._bid.winner_id = data.winner.id;
				console.log('bid_' + _this._bid.id, _this._bid, data)
				//_this.bid_price = data.data.price + data.bidStep;
				_this.setBackground(_this, data.winner.id)
			})
			// }
			this.$root.$on('hideFastbid', () => {
				this.isHidden = true
			})
			//console.log("SUBSCRIBING product_" + this._bid.Product.id);
			// this.sockets.subscribe("product_" + this._bid.Product.id, data => {
			// 	console.log("product_" + _this._bid.Product.id, data);
			// 	_this.winner = data.User;
			// 	_this.bid.price = data.data.price;
			// 	_this.bid.winner_id = data.winner_id;
			// 	//_this.bid_price = data.data.price + data.bidStep;
			// });
		}
	},
}
</script>
<style scoped>
.inactive {
	opacity: 0.7;
	background: #eee7e7;
}
.card {
	display: flex;
	flex-direction: column;
}
.button.is-text {
	text-decoration: none;
}
.product-title {
	margin-bottom: auto;
}
.buttons-tags {
	margin-top: 0.5rem !important;
	margin-bottom: 0;
}
.buttons-tags a:not(:last-child) {
	margin-right: 0.5rem;
}
.card-content {
	display: flex;
	flex-direction: column;
}
.winner {
	background-color: #e2fbe2;
}
.loser {
	background-color: #ffe6e6;
}
.running-data .icon {
	vertical-align: text-top;
}

.has-ribbon-left {
	position: relative;
	float: left;
}
.fade-enter-active {
	transition: all .3s ease;
	color: rgb(26, 69, 74);
}
.fade-leave-active {
	transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .fade-leave-to {
	transform: translateX(10px);
	opacity: 50;
	color: #eee7e7;
}
</style>
